import { render, staticRenderFns } from "./AccountSettingLinks.vue?vue&type=template&id=f8fd46aa"
import script from "./AccountSettingLinks.vue?vue&type=script&lang=js"
export * from "./AccountSettingLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports